// extracted by mini-css-extract-plugin
export default {"element":"price_element__We5O2","block":"price_block__ZM+Un"};